import React, {
  useEffect,
  useState,
  useRef,
  useContext,
  useCallback,
} from "react";
import { PubSub } from "aws-amplify";
import { backendConfig } from "../../../config/BackendConfig";
import classNames from "classnames";
import Modal from "../../../utils/components/common/modal";
import Icons from "../../../utils/components/icons";
import { getWifiStrength } from "../../../utils/utils";
import DropDown from "../../../utils/components/common/dropdown/dropdown";
import "./WifiListing.scss";
import ModalComponent from "../../../utils/components/common/modalComponent/ModalComponent";
import { useTranslation } from "react-i18next";
import { USER_ROLES } from "../../../utils/constants/userConstants";
import { UserContext } from "../../../layouts/MainLayout";
import { performDeviceWifiConfigOperations } from "../../../services/DeviceService";
import LoadingSpinner from "../../../utils/components/common/loadingSpinner/LoadingSpinner";

const WifiListing = ({ deviceId, deviceName, deviceMode, cancel }) => {
  const { loggedInUserRole, userCognitoData } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isChangeOccur, setIsChangeOccur] = useState(false);
  const [viewPass, setViewPass] = useState(true);
  const [editPreferredNetwork, setEditPreferredNetwork] = useState(false);

  const [currentPosition, setCurrentPosition] = useState(null);
  const [isPrioritising, setIsPrioritising] = useState(false);
  const [selectPriorityWifi, setSelectPriorityWifi] = useState({
    ssid: "",
  });

  const [wifiData, setWifiData] = useState({});
  const [preferredWifiList, setPreferredWifiList] = useState([]);
  const [scanWifiList, setScanWifiList] = useState([]);
  const [activeScanNetwork, setActiveScanNetwork] = useState({});
  const [activeScanNetworkPass, setActiveScanNetworkPass] = useState("");
  const [selectForgetWifi, setSelectForgetWifi] = useState({});
  const [newPreferredNetwork, setNewPreferredNetwork] = useState({
    ssid: "",
    security: "wpa2",
    password: "",
  });

  const [IsCancelModal, setIsCancelModal] = useState(false);
  const [isCancelActive, setIsCancelActive] = useState(false);
  const [IsRefreshModal, setIsRefreshModal] = useState(false);
  const [saveAsPreferredModal, setSaveAsPreferredModal] = useState(false);
  const [forgetWifiModal, setForgetWifiModal] = useState(false);
  const [isSuccessModal, setIsSuccessModal] = useState(false);
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [isNewNetworkModal, setIsNewNetworkModal] = useState(false);
  const [isRefreshFailedModal, setIsRefreshFailedModal] = useState(false);
  const [validation, setValidation] = useState({
    usernameInvalid: false,
    passwordEmpty: false,
  });

  const wifiStrengthIcon = {
    Excellent: Icons.wifiExcellent,
    VeryGood: Icons.wifiVG,
    Okey: Icons.wifiOkey,
    Poor: Icons.wifiPoor,
  };

  const [canNotEditModal, setCanNotEditModal] = useState(false);
  const { t } = useTranslation("wifiListing");

  const loadingTimeout = useRef(null);

  const cancelLoading = (callFrom = "") => {
    setIsLoading(false);
    if (callFrom === "saveToDevice") {
      setIsErrorModal(true);
    }
  };

  const setLoading = (callFrom = "") => {
    clearTimeout(loadingTimeout.current);
    setIsLoading(true);
    loadingTimeout.current = setTimeout(() => cancelLoading(callFrom), 15000);
  };

  const findAddUpdateDeleteWifiList = useCallback((updatedArray) => {
    let originalArr =
      JSON.parse(localStorage.getItem("originalPreferredWifiList")) || [];
    let isEqual = (obj1, obj2) => JSON.stringify(obj1) === JSON.stringify(obj2);

    let additions = [];
    let updates = [];
    let deletions = [];

    let originalMap = new Map(originalArr.map((item) => [item.ssid, item]));
    let updatedMap = new Map(updatedArray.map((item) => [item.ssid, item]));

    // Check for additions and updates
    updatedArray.forEach((item) => {
      let originalItem = originalMap.get(item.ssid);
      if (!originalItem) {
        additions.push(item);
      } else if (!isEqual(originalItem, item)) {
        updates.push(item);
      }
    });

    // Check for deletions
    originalArr.forEach((item) => {
      if (!updatedMap.has(item.ssid)) {
        deletions.push(item);
      }
    });

    return {
      additions,
      updates,
      deletions,
    };
  }, []);

  const ssidArray = useCallback((list) => {
    return list.length ? list?.map((item) => item.ssid) : [];
  }, []);

  const performWifiOperationsAPI = useCallback(
    async (callFrom, preWifiList) => {
      try {
        let payload = {
          deviceId: deviceId,
          clearProfiles: false,
          listProfiles: true,
          connection: true,
          scanNetworks: true,
          addProfiles: null,
          auditActions: null,
        };

        if (callFrom === "saveToDevice") {
          const result = findAddUpdateDeleteWifiList(preWifiList);
          let originalArr =
            JSON.parse(localStorage.getItem("originalPreferredWifiList")) || [];

          let orgWifiList = ssidArray(originalArr);
          let updatedWifiList = ssidArray(preWifiList);

          let isOrderChange =
            JSON.stringify(orgWifiList) !== JSON.stringify(updatedWifiList);

          let addList = ssidArray(result.additions);
          let editList = ssidArray(result.updates);
          let delList = ssidArray(result.deletions);

          let isOrderSend = addList.length || delList.length || isOrderChange;

          payload = {
            ...payload,
            clearProfiles: true,
            addProfiles: preWifiList,
            auditActions: {
              networkAdded: addList,
              networkEdited: editList,
              networkRemoved: delList,
              networkOrder: {
                oldOrder: isOrderSend ? ssidArray(originalArr) : [],
                newOrder: isOrderSend ? ssidArray(preWifiList) : [],
              },
            },
          };
        }

        let res = await performDeviceWifiConfigOperations(payload);
        return res;
      } catch (err) {
        setErrorModal(true);
      }
    },
    []
  );

  const getWifiList = async (
    isRefreshCall = false,
    callFrom = "",
    preWifiList = []
  ) => {
    try {
      setLoading(callFrom);

      let res = await performWifiOperationsAPI(callFrom, preWifiList);

      let url =
        "chorus/" +
        backendConfig.PUBSUB_ENV +
        "/users/" +
        userCognitoData.username +
        "/notifications/events";

      PubSub.subscribe(url).subscribe({
        next: (data) => {
          if (res?.data?.transactionToken === data?.value?.transactionToken) {
            data.value.data = data.value;
            handleWiFiSub(data);
            if (callFrom === "saveToDevice") {
              setIsSuccessModal(true);
            }
          }
        },
        error: (error) => console.error(error),
        close: () => console.log(""),
      });
    } catch (error) {
      if (callFrom === "saveToDevice") {
        setIsErrorModal(true);
      }
      clearTimeout(loadingTimeout.current);
      setIsLoading(false);
      isRefreshCall && setIsRefreshFailedModal(true);
    }
  };

  const viewPassword = () => {
    setViewPass(!viewPass);
  };

  const checkConnection = (item) => {
    return (
      wifiData?.data?.connection && wifiData?.data?.connection?.ssid === item
    );
  };

  const onPassChange = (e) => {
    setValidation({ ...validation, passwordEmpty: false });
    setActiveScanNetworkPass(e.target.value);
  };

  const saveAsPreferred = (item = null) => {
    setIsChangeOccur(true);
    const activeScanWifi = item || activeScanNetwork;
    const formatedScanNetwork = {
      ssid: activeScanWifi.ssid,
      security: activeScanWifi?.security,
    };
    if (activeScanWifi?.security?.toLowerCase() !== "open") {
      formatedScanNetwork.password = activeScanNetworkPass;
      if (activeScanNetworkPass.length === 0) {
        setValidation({ ...validation, passwordEmpty: true });
        return false;
      }
    }
    const prefList = [...preferredWifiList, formatedScanNetwork];
    const scanList = [...scanWifiList];
    const activeScanNetworkIndex = scanList.findIndex(
      (item) => item.ssid === activeScanWifi.ssid
    );
    scanList.splice(activeScanNetworkIndex, 1);
    setScanWifiList(scanList);
    setPreferredWifiList(prefList);
    setActiveScanNetwork({});
    setActiveScanNetworkPass("");
    setSaveAsPreferredModal(false);
  };

  const saveNewPreferred = () => {
    setIsChangeOccur(true);
    const list = [...preferredWifiList];
    if (editPreferredNetwork) {
      const index = preferredWifiList.findIndex(
        (item) => item.ssid === newPreferredNetwork.ssid
      );
      list[index].password = newPreferredNetwork.password;
      if (
        newPreferredNetwork?.security !== "open" &&
        newPreferredNetwork.password.length === 0
      ) {
        setValidation({ ...validation, passwordEmpty: true });
        return false;
      }
      setPreferredWifiList([...list]);
    } else {
      const data = {
        ssid: newPreferredNetwork.ssid,
        security: newPreferredNetwork?.security,
      };
      if (newPreferredNetwork.ssid.length === 0) {
        setValidation({ ...validation, usernameInvalid: true });
        return false;
      }
      if (newPreferredNetwork?.security !== "open") {
        data.password = newPreferredNetwork.password;
        if (newPreferredNetwork.password.length === 0) {
          setValidation({ ...validation, passwordEmpty: true });
          return false;
        }
      } else {
        setValidation({ ...validation, passwordEmpty: false });
      }
      setPreferredWifiList([...preferredWifiList, { ...data }]);
    }
    setNewPreferredNetwork({
      ssid: "",
      security: "wpa2",
      password: "",
    });
    setEditPreferredNetwork(false);
    setIsNewNetworkModal(false);
  };

  const setEditNetwork = (item) => {
    setEditPreferredNetwork(true);
    setNewPreferredNetwork({ ...item });
    setIsNewNetworkModal(true);
  };

  const openSaveAsPreferredModal = (item) => {
    if (item?.security?.toLowerCase() === "open") {
      saveAsPreferred(item);
    } else {
      setActiveScanNetwork(item);
      setSaveAsPreferredModal(true);
    }
  };

  const getForgetWifi = (item) => {
    setSelectForgetWifi(item);
    setForgetWifiModal(true);
  };

  const saveForgetWifi = () => {
    setIsChangeOccur(true);
    const list = [...preferredWifiList];
    const wifiIndex = preferredWifiList.findIndex(
      (item) => item.ssid === selectForgetWifi.ssid
    );
    list.splice(wifiIndex, 1);
    setPreferredWifiList(list);
    setForgetWifiModal(false);
  };

  const handleCancel = () => {
    if (isChangeOccur) {
      setIsCancelModal(true);
    } else {
      cancel();
    }
  };

  const handleRefresh = () => {
    if (deviceMode !== "OFFLINE") {
      if (isChangeOccur) {
        setIsRefreshModal(true);
      } else {
        getWifiList();
      }
    } else {
      setIsRefreshFailedModal(true);
    }
  };

  const setPriorityItem = (item) => {
    if (item.ssid !== selectPriorityWifi.ssid) {
      setSelectPriorityWifi(item);
      const currentIndex = preferredWifiList.findIndex(
        (elem) => elem.ssid.toLowerCase() === item.ssid.toLowerCase()
      );
      setCurrentPosition(currentIndex);
    } else {
      setSelectPriorityWifi({ ssid: "" });
    }
  };

  const handlePriority = async (priority, item) => {
    setIsCancelActive(true);
    setIsPrioritising(false);
    setIsChangeOccur(true);
    const list = [...preferredWifiList];
    if (priority === "up") {
      const getBatch = list.splice(currentPosition - 1, 2);
      list.splice(currentPosition - 1, 0, getBatch[1], getBatch[0]);
    } else {
      const getBatch = list.splice(currentPosition, 2);
      list.splice(currentPosition, 0, getBatch[1], getBatch[0]);
    }
    setPreferredWifiList(list);
    setSelectPriorityWifi(item);
    const currentIndex = list.findIndex(
      (elem) => elem?.ssid?.toLowerCase() === item?.ssid?.toLowerCase()
    );
    setCurrentPosition(currentIndex);
    setIsPrioritising(true);
  };

  const handleInputChange = (e) => {
    setValidation({ ...validation, usernameInvalid: false });
    if (e.target.name === "password") {
      setValidation({ ...validation, passwordEmpty: false });
    }
    setNewPreferredNetwork({
      ...newPreferredNetwork,
      [e.target.name]: e.target.value,
    });
  };

  const resetData = () => {
    setActiveScanNetwork({});
    setActiveScanNetworkPass("");
    setSelectForgetWifi({});
    setIsChangeOccur(false);
    viewPassword();
  };

  const isOpenNetwork = (security) => {
    return security === "open";
  };

  const saveToDevice = async () => {
    try {
      await getWifiList(false, "saveToDevice", preferredWifiList);
      resetData();
    } catch (error) {
      clearTimeout(loadingTimeout.current);
      setIsLoading(false);
      resetData();
      setIsSuccessModal(false);
      setIsErrorModal(true);
    }
  };
  const handleWiFiSub = (data) => {
    clearTimeout(loadingTimeout.current);
    setIsLoading(false);
    if (data?.value?.data?.listProfiles) {
      const apiData = data?.value;
      const scanNetworksList = [];
      if (
        data?.value?.data?.scanNetworks &&
        data?.value?.data?.scanNetworks.length > 0
      ) {
        data.value.data.scanNetworks.forEach((elem) => {
          const isInListProfiles = data?.value?.data?.listProfiles.findIndex(
            (item) => item.ssid === elem.ssid
          );
          if (isInListProfiles === -1) {
            scanNetworksList.push(elem);
          }
        });
      }
      apiData.data.scanNetworks = scanNetworksList;
      setWifiData(apiData);
      localStorage.setItem(
        "originalPreferredWifiList",
        JSON.stringify(data?.value?.data?.listProfiles)
      );
      setPreferredWifiList(data?.value?.data?.listProfiles);
      setScanWifiList(scanNetworksList);
    } else {
      if (data?.value?.data?.success === true) {
        resetData();
        setIsSuccessModal(true);
        setIsErrorModal(false);
      } else {
        resetData();
        setIsSuccessModal(false);
        setIsErrorModal(true);
      }
    }
  };

  useEffect(() => {
    getWifiList();

    return () => {
      localStorage.removeItem("originalPreferredWifiList");
    };
  }, []);

  const onDoubleClickOfNetwork = (item) => {
    if (USER_ROLES.viewOnlyUserCorp === loggedInUserRole) return;
    /**If it's a connected network then show pop-up else update edit network state */
    if (checkConnection(item.ssid)) {
      setCanNotEditModal(true);
    } else {
      setEditNetwork(item);
    }
  };

  return (
    <div className="wifiContainer">
      <p className="wifiHeading" id="wifi_settings">
        Device Wifi Settings - {deviceName}
      </p>
      {isLoading && <LoadingSpinner />}
      <>
        <div className="preferredNetworkWrapper">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <span className="wifiHeading" id="preferred_networks">
                Preferred Networks
              </span>
              <div className="ms-3 d-flex">
                <button
                  className="roundBtn circle large withHover"
                  id="move_up"
                  disabled={
                    !isPrioritising ||
                    currentPosition === 0 ||
                    selectPriorityWifi.ssid === ""
                  }
                  onClick={() => handlePriority("up", selectPriorityWifi)}
                >
                  {Icons.wifiChevronUp}
                </button>
                <button
                  className="roundBtn circle large withHover"
                  id="move_down"
                  disabled={
                    !isPrioritising ||
                    currentPosition === preferredWifiList.length - 1 ||
                    selectPriorityWifi.ssid === ""
                  }
                  onClick={() => handlePriority("down", selectPriorityWifi)}
                >
                  {Icons.wifiChevronDown}
                </button>
              </div>
            </div>
            <div className="d-flex align-items-center">
              <button
                type="button"
                id="refresh"
                className="verticalBtn"
                title="Refresh"
                onClick={handleRefresh}
              >
                {Icons.refreshIcon}
                {/* <span>Refresh</span> */}
              </button>
              <button
                type="button"
                className={classNames("roundBtn", {
                  dark: !isChangeOccur,
                  primary: isChangeOccur,
                })}
                id="save_to_device"
                onClick={saveToDevice}
                disabled={
                  !isChangeOccur ||
                  USER_ROLES.viewOnlyUserCorp === loggedInUserRole
                }
              >
                <span>{t("save_to_device")}</span>
              </button>
            </div>
          </div>
          <table className="table" id="preferred_network_list">
            <thead>
              <tr>
                <th scope="col" className="text-right">
                  Name
                </th>
                <th scope="col" className="text-right">
                  Security
                </th>
                <th scope="col" className="text-center">
                  Wifi Strength
                </th>
                <th scope="col" className="text-right">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {preferredWifiList.length > 0 ? (
                preferredWifiList.map((item, index) => (
                  <tr
                    className={classNames("wifi-row" + index, {
                      active: selectPriorityWifi?.ssid === item?.ssid,
                      selectedNetwork: checkConnection(item?.ssid),
                    })}
                    key={`preferedNetwork_${index}`}
                    onClick={() => {
                      setPriorityItem(item);
                      setIsPrioritising(true);
                    }}
                    onDoubleClick={() => onDoubleClickOfNetwork(item)}
                  >
                    <td>
                      <div className="d-flex align-items-center">
                        <span
                          className={
                            "wifiName " +
                            classNames({
                              selectedNetwork: checkConnection(item?.ssid),
                            })
                          }
                        >
                          {item?.ssid}
                        </span>
                        {checkConnection(item?.ssid) && (
                          <span className="connectedWifi">
                            <img
                              alt="settings"
                              src={require("../../../assets/images/icons/wifiConnected.png")}
                              className="img-fluid"
                            />
                          </span>
                        )}
                      </div>
                    </td>
                    <td
                      className={
                        "text-right " +
                        classNames({
                          selectedNetwork: checkConnection(item?.ssid),
                        })
                      }
                    >
                      {!item?.security || item?.security === "error"
                        ? "unknown"
                        : item?.security}
                    </td>
                    <td className="text-center">
                      {item?.rssi
                        ? wifiStrengthIcon[getWifiStrength(item?.rssi)]
                        : wifiStrengthIcon["Excellent"]}
                    </td>
                    <td className={`text-right forgot-btn-col`}>
                      <button
                        type="button"
                        className="action"
                        id="forgetbutton"
                        onClick={(e) => {
                          e.preventDefault();
                          getForgetWifi(item);
                        }}
                        disabled={
                          checkConnection(item?.ssid) ||
                          USER_ROLES.viewOnlyUserCorp === loggedInUserRole
                        }
                      >
                        {t("forget")}
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="active">
                  <td></td>
                  <td></td>
                  {!isLoading && (<td className="text-start">{t("no-result")}</td>)}
                  <td></td>
                </tr>
              )}
              {preferredWifiList.length <= 3 && (
                <tr className="active">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="text-right">
                    <button
                      type="button"
                      id="add_network"
                      className="action"
                      onClick={(e) => {
                        e.preventDefault();
                        setIsNewNetworkModal(true);
                      }}
                      disabled={
                        USER_ROLES.viewOnlyUserCorp === loggedInUserRole
                      }
                    >
                      {t("add")}
                    </button>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="preferredNetworkWrapper mt-5">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <span className="wifiHeading" id="available_networks">
                Other Available Networks
              </span>
            </div>
          </div>
          <table className="table" id="available_networks_list">
            <thead>
              <tr>
                <th scope="col" className="text-right">
                  Name
                </th>
                <th scope="col" className="text-right">
                  Security
                </th>
                <th scope="col" className="text-center">
                  Wifi Strength
                </th>
                <th scope="col" className="text-right">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {scanWifiList.length > 0 ? (
                scanWifiList.map((item, index) => (
                  <tr className="active" key={`preferedNetwork_${index}`}>
                    <td>{item.ssid}</td>
                    <td className="text-right">
                      {!item?.security || item?.security === "error"
                        ? "unknown"
                        : item?.security}
                    </td>
                    <td className="text-center">
                      {wifiStrengthIcon[getWifiStrength(item?.rssi)]}
                    </td>
                    <td className="text-right">
                      <button
                        type="button"
                        onClick={() => openSaveAsPreferredModal(item)}
                        disabled={
                          preferredWifiList.length > 3 ||
                          item?.security?.toLowerCase() === "open" ||
                          USER_ROLES.viewOnlyUserCorp === loggedInUserRole
                        }
                        id="save_as_preferred"
                      >
                        {t("save_as_preferred")}
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="active">
                  <td></td>
                  <td></td>
                  {!isLoading && (<td className="text-start">{t("no-result")}</td>)}
                  <td></td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="d-flex justify-content-end align-items-center mb-3 mt-3">
          <button
            type="button"
            id="cancel"
            onClick={handleCancel}
            className={`roundBtn cancelBtn ${
              isCancelActive ? "active" : "dark"
            }`}
          >
            <span>Cancel</span>
          </button>
        </div>
      </>

      <ModalComponent
        idName="cancelModal"
        isOpen={IsCancelModal}
        onCloseModal={() => setIsCancelModal(false)}
        descriptionText={t("cancel_message")}
        needConfirmation={true}
        onConfirm={() => {
          resetData();
          setIsCancelModal(false);
          cancel();
        }}
        onClose={() => setIsCancelModal(false)}
      ></ModalComponent>

      <ModalComponent
        idName="refreshModal"
        isOpen={IsRefreshModal}
        onCloseModal={() => setIsCancelModal(false)}
        descriptionText={t("refresh_warning_message")}
        needConfirmation={true}
        onConfirm={() => {
          resetData();
          setPreferredWifiList([]);
          setScanWifiList([]);
          setIsRefreshModal(false);
          getWifiList(true);
        }}
        onClose={() => setIsRefreshModal(false)}
      ></ModalComponent>

      <ModalComponent
        idName="saveSuccessModal"
        isOpen={isSuccessModal}
        onCloseModal={() => setIsSuccessModal(false)}
        descriptionText={t("network_change_success_message")}
      ></ModalComponent>

      <ModalComponent
        idName="saveErrorModal"
        isOpen={isErrorModal}
        onCloseModal={() => setIsErrorModal(false)}
        descriptionText={t("network_change_failure_message")}
      ></ModalComponent>

      <ModalComponent
        idName="saveErrorModal"
        isOpen={errorModal}
        onCloseModal={() => setErrorModal(false)}
        descriptionText={t("somethingWentWrong")}
      ></ModalComponent>

      <ModalComponent
        idName="forgetWifiModal"
        isOpen={forgetWifiModal}
        onCloseModal={() => setForgetWifiModal(false)}
        descriptionText={t("remove_wifi_warning_message", {
          wifiSSID: selectForgetWifi?.ssid,
        })}
        needConfirmation={true}
        onConfirm={() => {
          saveForgetWifi();
        }}
        onClose={() => setForgetWifiModal(false)}
      ></ModalComponent>

      <Modal
        isOpen={saveAsPreferredModal}
        onCloseModal={() => setSaveAsPreferredModal(false)}
        className="smallModal"
      >
        <p className="fs-4 fw-semibold mt-3 mb-2 ">Save Network to Device</p>
        <div className="fieldset mb-4">
          <label>Network Name</label>
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              value={activeScanNetwork.ssid}
              id="username"
              maxLength="32"
              placeholder="Network Name"
              disabled
              style={{ color: "#9B9B9B" }}
            />
          </div>
        </div>
        <div className="fieldset mb-4">
          <label>Password</label>
          <div className="input-group ">
            <input
              type={viewPass ? "password" : "text"}
              className="form-control"
              value={activeScanNetworkPass}
              id="password"
              maxLength="64"
              placeholder="Enter password"
              aria-describedby="basic-addon1"
              name="password"
              onChange={onPassChange}
            />
            <span
              className="input-group-text"
              id="basic-addon1"
              name="viewpass"
              onClick={viewPassword}
            >
              {!viewPass && Icons.eyeOpenIcon}
              {viewPass && Icons.eyeCloseIcon}
            </span>
          </div>
          {validation.passwordEmpty && <span>Please enter Password</span>}
        </div>
        <div className="fluid  mb-4 d-flex justify-content-end">
          <button
            className="roundBtn dark fs-6 mx-2"
            onClick={() => {
              setActiveScanNetwork({});
              setActiveScanNetworkPass("");
              setSaveAsPreferredModal(false);
            }}
          >
            <span>Cancel</span>
          </button>
          <button
            className="roundBtn primary fs-6 mx-2"
            onClick={() => saveAsPreferred()}
            disabled={!activeScanNetworkPass.length}
          >
            <span>Save</span>
          </button>
        </div>
      </Modal>

      <Modal
        isOpen={isNewNetworkModal}
        onCloseModal={() => setIsNewNetworkModal(false)}
        className="smallModal"
      >
        {!editPreferredNetwork && (
          <p className="fs-4 fw-semibold mt-3 mb-2 " id="save_network">
            {t("add_network")}
          </p>
        )}
        {editPreferredNetwork && (
          <p className="fs-4 fw-semibold mt-3 mb-2 " id="edit_network">
            Edit Network
          </p>
        )}
        <div className="fieldset mb-4">
          <label id="name_label">Network Name</label>
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              name="ssid"
              value={newPreferredNetwork.ssid}
              id="name"
              placeholder={t("add_network_placeholder")}
              maxLength="32"
              onChange={handleInputChange}
              disabled={editPreferredNetwork}
            />
          </div>
          {validation.usernameInvalid && <span>Please enter network name</span>}
        </div>
        {!editPreferredNetwork && (
          <div className="fieldset mb-4">
            <label id="security_label">Security</label>
            <DropDown
              options={[
                { label: "WPA2", value: "wpa2" },
                { label: "WPA3", value: "wpa3" },
                { label: "Open", value: "open" },
              ]}
              hideSelectedOption
              wrapperClass="default"
              autoid="network_types"
              value={newPreferredNetwork?.security}
              onSelection={(val) => {
                setNewPreferredNetwork({
                  ...newPreferredNetwork,
                  security: val,
                });
              }}
            />
          </div>
        )}
        <div className="fieldset mb-4">
          <label id="password_label">Password</label>
          <div className="input-group ">
            <input
              type={viewPass ? "password" : "text"}
              className="form-control"
              value={newPreferredNetwork.password}
              id="password"
              maxLength="64"
              placeholder={t("password_placeholder_add_network")}
              aria-describedby="basic-addon1"
              name="password"
              onChange={handleInputChange}
              disabled={isOpenNetwork(newPreferredNetwork?.security)}
            />
            <span
              className="input-group-text"
              id="viewpass"
              name="viewpass"
              onClick={viewPassword}
            >
              {!viewPass && Icons.eyeOpenIcon}
              {viewPass && Icons.eyeCloseIcon}
            </span>
          </div>
          {validation.passwordEmpty && <span>Please enter Password</span>}
        </div>
        <div className="fluid  mb-4 d-flex justify-content-end">
          <button
            className="roundBtn dark fs-6 mx-2"
            id="cancel"
            onClick={() => {
              setIsNewNetworkModal(false);
              setEditPreferredNetwork(false);
              setNewPreferredNetwork({
                ssid: "",
                security: "wpa2",
                password: "",
              });
            }}
          >
            <span>Cancel</span>
          </button>
          <button
            className="roundBtn primary fs-6 mx-2"
            id="save"
            disabled={
              !(
                newPreferredNetwork.password.length > 0 &&
                newPreferredNetwork.ssid.length > 0
              )
            }
            onClick={() => saveNewPreferred()}
          >
            <span>Save</span>
          </button>
        </div>
      </Modal>

      <ModalComponent
        idName="edit-not-allowed-modal"
        isOpen={canNotEditModal}
        onCloseModal={() => {
          setCanNotEditModal(true);
          setCanNotEditModal(false);
        }}
        descriptionText={t("can_not_edit")}
      />

      <ModalComponent
        idName="refreshFailedModal"
        isOpen={isRefreshFailedModal}
        onCloseModal={() => setIsRefreshFailedModal(false)}
        descriptionText={
          deviceMode === "OFFLINE"
            ? t("refresh_offline_failure_message")
            : t("refresh_failure_message")
        }
      ></ModalComponent>
    </div>
  );
};

export default WifiListing;
